module.exports = __webpack_public_path__ + "static/media/house-6.33578515.jpg";